const config = {
  config: {
    apiChatStartURL: "getUUIDurl",
    introText: "Hi! Nice to meet you.",
    teaser: "Hey there, is there something I can help you find?",
    images: [
      "https://picsum.photos/id/1018/1000/600/",
      "https://picsum.photos/id/1015/1000/600/",
      "https://picsum.photos/id/1019/1000/600/",
    ],
    floorplans: [
      {
        id: 2,
        name: "Second floor",
        care_types: ["assisted"],
        room_size: "One Bedroom",
        care_description:
          "some wild description\r\nsome wild description\r\nsome wild description\r\nsome wild description",
        cost: 300,
        image: "https://uhdenver.com/wp-content/uploads/2017/10/Small4B3B1.jpg",
        sq_feet: 850,
        num_baths: 1,
        move_in_special: "something special",
      },
      {
        id: 1,
        name: "First floor",
        care_types: ["assisted"],
        room_size: "One Bedroom",
        care_description:
          "some wild description\r\nsome wild description\r\nsome wild description\r\nsome wild description",
        cost: 300,
        image: "https://longspeakmedia.com/wp-content/uploads/2019/01/Sample-FP.png",
        sq_feet: 850,
        num_baths: 1,
        move_in_special: "something special",
      },
    ],
    videos: ["https://www.youtube.com/watch?v=MuxB2zACza0"],
    digital_tours: [
      '<iframe src="http://www.weather.gov/" frameborder="0"> </iframe>',
      "https://www.youtube.com/watch?v=MuxB2zACza0",
    ],
  },
  modules: {
    "1": {
      type: "option",
      text: "test module",
      answers: [{ text: "gallery", action: 2 }],
    },
    "2": {
      role: "gallery",
      type: "option",
      answers: [{ text: "youtube", action: 3 }],
    },
    "3": {
      type: "option",
      role: "videos",
      text: "Watch some youtube",
      answers: [
        { text: "virtual tour", action: 4 },
        { text: "floorplans", action: 5 },
      ],
    },
    "4": {
      type: "option",
      role: "digital_tours",
    },
    "5": {
      type: "option",
      role: "floorplan",
    },
  },
};

export default config;
